import axiosInstance from "../axiosClient";
import { addRecharge, addSubscription, rechargeDelete, rechargeList, update_recharge } from "../config";

export const getRechages = async (name,limit,start_key) => {
    let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.get(`${rechargeList}${queryString}`);
};

export const createRecharge =  async(data) => {
  return await axiosInstance.post(addRecharge,data);
};

export const updateRecharge = async(data) =>{
  return await axiosInstance.patch(update_recharge,data)
}
export const deleteRecharge = async (id) => {
  let queryParams = [];
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.delete(`${rechargeDelete}${queryString}`);
}


export const createSubscription =  async(data) => {
  return await axiosInstance.post(addSubscription,data);
};
